import * as React from "react";
import Format from "../../atoms/format"

/**
 * Internal dependencies.
 */
import './_table.scss';


const Table = ( props ) => {

	const tableID = props.tableID;
	const tableData = props.tableData;
	const tableType = props.tableType;
	const toggleType = props.toggleType;
	const asteriskLabel = props.asteriskLabel;

  // set atom class
  const atomClassName = 'table col-md-10'+ " is-type-"+tableType + " is-toggle-type-"+toggleType;
  var atomClass = props.className != undefined ? atomClassName + ' ' + props.className : atomClassName;

	const handleRowClick = (event) => {
		event.currentTarget.classList.toggle('active');
	}

  return (
		<div className="table-wrap row">
			{
				tableData.notes && (
					<div className={`fs-13 mb-0 ${'' ?? tableData.notes.align}`}>{tableData.notes.content}</div>
				)
			}
			<table className={ atomClass } id={tableID}>
				{
					tableData.headers &&
					<thead>
						{ tableData.headers?.map((th,idx) => {
								return (
									th.cols &&
										<tr key={`table-head-${idx}`}>
											{
												th.cols.map((thCol,tcIdx) => {
													// set default colspan = 1
													let colspan = 1;

													// if there is a colspan array...
													if (tableData.headers[idx].colspan){
														if (tableData.headers[idx].colspan[tcIdx]){
															// match current th to its colspan value
															colspan = tableData.headers[idx].colspan[tcIdx];
														}
													}
													return (
														<th key={`table-head-col-${tcIdx}`} colSpan={colspan.toString()}>{thCol}</th>
													)
												})
											}
										</tr>

								)
							}) }
					</thead>
				}
				{
					tableData.rows &&
					<tbody>
						{
							tableData.rows?.map((dataRow,dataRowId) => {

								let rowClasses = [];

								if (dataRow.className) rowClasses.push(dataRow.className);
								if (tableType == 'line-chart') rowClasses.push('data-line-src');
								if (dataRow.rowHeader == null) rowClasses.push('spacer');

								return (
									dataRow &&
										<tr key={`table-row-${dataRowId}`} className={ rowClasses.join(" ") } onClick={handleRowClick}>
											{
												dataRow.rowHeader != null && (
													<th colSpan={dataRow.rowHeader.colspan > 1 ? dataRow.rowHeader.colspan : undefined}>{dataRow.rowHeader.val}</th>
												)
											}
											{
												dataRow.cols.length > 0 &&
												dataRow.cols.map((dataCol,dataColIdx) => {
													let colspan = false;

													// if there is a colspan array...
													if (tableData.rows[dataRowId].colspan){
														if (tableData.rows[dataRowId].colspan[dataColIdx]){
															// match current th to its colspan value
															colspan = tableData.rows[dataRowId].colspan[dataColIdx];
														}
													}

													return (
														<td key={`table-row-col-${dataColIdx}`} colSpan={colspan.toString()}>
															<Format dataVal={dataCol.val} dataType={dataCol.format} />
														</td>
													)

												})
											}
										</tr>
								)
							})
						}
					</tbody>
				}
			</table>
			{
				asteriskLabel && (
				<div className="fs-14 text-gray">
					* { asteriskLabel }
				</div>
				)
			}
		</div>
  )
}

export default Table
